import { render, staticRenderFns } from "./SystockFiltros.vue?vue&type=template&id=5868f7ff"
import script from "./SystockFiltros.vue?vue&type=script&lang=js"
export * from "./SystockFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports